import { Dialog, DialogActions, DialogContent, LinearProgress } from '@mui/material';
import React, { useEffect, useState } from 'react'

import { CloudUpload, RecordVoiceOver } from '@mui/icons-material';
import MicRecorder from 'mic-recorder-to-mp3';
import { useAlert } from '../../../../context/AlertContext';

const Mp3Recorder = new MicRecorder({ bitRate: 8 });


function VoiceCall({callBack}) {
    const {AppAlert } = useAlert();
    const [dialogStatus,setDialogStatus] = useState("");
    const [savingInProgress,setSavingStatus] = useState("");
    const [recording,setRecordingStatus] = useState(false);
    const [audioBase64,setAudioBase64] = useState(null);
    


    const base64ToUrl = (b64Data, contentType = 'audio/mp3') => {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];
        // Break the data into chunks for efficiency, especially for large files
        for (let offset = 0; offset < byteCharacters.length; offset += 512) {
            const slice = byteCharacters.slice(offset, offset + 512);
            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        // Create a Blob from the array of chunks
        const blob = new Blob(byteArrays, { type: contentType });
        // Create a URL representing the Blob data
        return URL.createObjectURL(blob);
    }


    const blobToBase64 = (blob) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => {
            const dataUrl = reader.result;
            const base64String = dataUrl.split(',')[1];
            console.log(base64String);    
            resolve(base64String);
                
            };
            reader.onerror = (error) => {
                reject(error);
            };
            reader.readAsDataURL(blob);
        });
    };


    const onStart = () => {
        Mp3Recorder.start().then(()=>{
            setAudioBase64(null);
            setRecordingStatus(true);
        })

        /*
        setTimeout(()=>{
            if(recording){
                onStop();
            }
        },6000)
        */
    }

    const onStop = () => {
        Mp3Recorder.stop().getMp3()
        .then(([buffer, blob]) => {
            setRecordingStatus(false);
            blobToBase64(blob).then(res=>{
                setAudioBase64(res);
            })
        }).catch((e) => console.log(e));
    }


    

    const sendAudio = () =>{
        if(audioBase64 !== null){
            console.log(audioBase64);
            callBack(audioBase64);
            setTimeout(handleClose,1000)
            
        }
    }


    const handleClose = () =>{
        setAudioBase64(null);
        setDialogStatus(false);
        
    }

    
    

    return (
        <>
            {(localStorage.portalId == "local-demo1" || localStorage.portalId == "global-demo3") &&
                <div className='btn btn-outline-danger ms-2' onClick={()=>{setDialogStatus(true); console.log("aaaaaa",audioBase64);} } ><RecordVoiceOver /></div>
            }
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={handleClose}
                maxWidth="sm"
                fullWidth={true}
            >
                <DialogContent>
                    <div className="text-center">
                        {!recording && <button type="button" className="btn btn-danger" onClick={onStart} >Start Recording</button>}
                        {recording && 
                            <div className="mt-3">
                                <h3 className="mb-3">Recording Audio...</h3>
                                <LinearProgress color="warning" /><button type="button" className="btn btn-danger mt-3" onClick={onStop} >Stop Recording</button>
                            </div>
                        }
                        {audioBase64 !== null && audioBase64 !== "" &&
                             <div className="mt-3 text-center">
                                
                                <div>
                                    <audio controls>
                                        <source src={base64ToUrl(audioBase64)} />
                                    </audio>
                                </div>
                                
                                <div>
                                    {/* <a download="text.mp3" href={audioBase64} className="btn btn-outline-primaru">Download</a>  */}
                                    <button className="btn btn-success float-end" onClick={sendAudio} ><CloudUpload/> Send</button>
                                </div>
                            </div>
                        }
                    </div>
                </DialogContent>
            </Dialog>
        </>
    )
}

export default VoiceCall